/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { spendRulesOverviewGet } from "../funcs/spendRulesOverviewGet.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { SpendRulesOverviewResult } from "../models/components/spendrulesoverviewresult.js";
import {
  GetSpendRulesOverviewRequest,
  GetSpendRulesOverviewSecurity,
} from "../models/operations/getspendrulesoverview.js";
import { unwrapAsync } from "../types/fp.js";

export class GramOverview extends ClientSDK {
  /**
   * getSpendRulesOverview spendRules
   *
   * @remarks
   * Get budgets overview metrics: aggregate card numbers plus current-window usage per rule.
   */
  async get(
    request?: GetSpendRulesOverviewRequest | undefined,
    security?: GetSpendRulesOverviewSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SpendRulesOverviewResult> {
    return unwrapAsync(spendRulesOverviewGet(
      this,
      request,
      security,
      options,
    ));
  }
}
